module.exports = __webpack_public_path__ + "static/c11-e3b3d11fdab867da2797fd2bb8a0b701.jpg";